import { render, staticRenderFns } from "./NavigationRoute.vue?vue&type=template&id=2035470c&"
import script from "./NavigationRoute.vue?vue&type=script&lang=js&"
export * from "./NavigationRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports